// extracted by mini-css-extract-plugin
export default {"preloader":"PreLoaderPage_preloader__ymfZm","fade":"PreLoaderPage_fade__XRer6"};